<template>
  <div>
    <BaseCard
      v-if="selectedShareOption === 'link'"
      gray
    >
      <BaseHeading mb>
        {{ $t('custom_booking_widget.online_booking_link') }}
      </BaseHeading>
      <BaseText mb>
        {{ $t('custom_booking_widget.online_booking_link_info') }}
      </BaseText>
      <BaseCodeField
        v-if="widgetLink"
        :code="widgetLink"
        v-test="'custom-widget-link'"
      />
      <BaseButton
        v-else
        :loading="loading"
        @click="mutate"
        v-test="'custom-widget-generate'"
      >
        {{ $t('custom_booking_widget.generate_link') }}
      </BaseButton>
    </BaseCard>
    <Snippet
      v-else
      :widgetId="widgetId"
      custom
      :loading="loading"
      @generate="mutate"
      v-test="'custom-widget-snippet'"
    />
  </div>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { storeToRefs } from 'pinia';
import { computed, ref, watch } from 'vue';
import { useMicroSiteStore } from '@/stores/micro-site';
import Snippet from '../Snippet.vue';
import { CREATE_CUSTOM_BOOKING_WIDGET } from './graphql';
import options from './options';

const { bookingWidgetUrl, loading: loadingQuery } = storeToRefs(
  useMicroSiteStore(),
);

const {
  selectedLocationIds,
  selectedServiceIds,
  selectedEmployeeIds,
  selectedShareOption,
} = options;
const widgetId = ref('');
const widgetLink = ref('');
const loading = computed(() => loadingMutation.value || loadingQuery.value);

const {
  mutate,
  onDone,
  loading: loadingMutation,
} = useMutation(CREATE_CUSTOM_BOOKING_WIDGET, () => ({
  variables: {
    input: {
      locationIds: selectedLocationIds.value,
      resourceIds: selectedEmployeeIds.value,
      serviceIds: selectedServiceIds.value,
    },
  },
}));

onDone(
  ({
    data: {
      createCustomBookingWidget: { customBookingWidget },
    },
  }) => {
    widgetId.value = customBookingWidget.publicId;
    if (bookingWidgetUrl.value) {
      widgetLink.value = `${bookingWidgetUrl.value}?widget_id=${widgetId.value}`;
    }
  },
);

watch(
  [selectedLocationIds, selectedServiceIds, selectedEmployeeIds],
  () => {
    widgetId.value = '';
    widgetLink.value = '';
  },
  {
    deep: true,
  },
);
</script>
